import React from "react";
import { Sun, Moon } from "lucide-react";
import Tooltip from "./Tooltip";
import { useTheme } from "../context/ThemeContext";

export default function ThemeToggle() {
  const { resolved, setMode } = useTheme();
  const isDark = resolved === "dark";

  const toggle = () => setMode(isDark ? "light" : "dark");

  return (
    <Tooltip label={isDark ? "Switch to light mode" : "Switch to dark mode"}>
      <button
        onClick={toggle}
        className="rounded-lg p-2 text-gray-600 transition-colors duration-150 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-800"
        aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      >
        {isDark ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
      </button>
    </Tooltip>
  );
}
